// extracted by mini-css-extract-plugin
export default {"container":"bS-z","title":"cS-z","link":"dS-z"};